import React from 'react';
import { Translate } from '../../i18n/LanguageProvider';

const FeatureDescription = ({ translationKey }) => (
	<article className='tile is-child notification is-primary content'>
		<Translate>{translationKey}</Translate>
	</article>
);

export default FeatureDescription;
